import { Component, OnInit } from '@angular/core';
import { StateService } from 'src/app/core/services/state.service';

@Component({
  selector: 'app-client-navbar',
  templateUrl: './client-navbar.component.html',
  styleUrls: ['./client-navbar.component.scss'],
})
export class ClientNavbarComponent implements OnInit {
  isLoggedIn: boolean;

  constructor(private readonly stateService: StateService) {}

  ngOnInit(): void {
    // Fork logout when switch role
    if (
      localStorage.getItem('isLoggedIn') &&
      (localStorage.getItem('role') === 'warehouse_staff' ||
        localStorage.getItem('role') === 'shop_staff')
    ) {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('shop_id');
      localStorage.removeItem('role');
      localStorage.removeItem('shop_pin');
      localStorage.removeItem('retailer_id');
      localStorage.removeItem('shop_code');
      this.stateService.cleanCurrentUser();
    }

    this.stateService.currentUser.subscribe(
      (user) => (this.isLoggedIn = !!user)
    );
  }
}
